import './MenuBlockDash.css';

import { BlockDash, Icon } from '@elotech/components';
import { useAuth } from 'common/hooks';
import { ReactNode, useMemo } from 'react';

import { SubMenu } from '../../type';
import { Only } from '../only';

export type MenuBlockDashProps<ROLE extends string | undefined = undefined> = {
  icon: string;
  title: string;
  description?: ReactNode;
  error?: boolean;
  onClick?(): void;
  submenus?: SubMenu<ROLE>[];
  loading?: boolean;
  blockVisualization?: boolean;
  role?: ROLE | ROLE[];
};

const MenuBlockDash = <ROLE extends string | undefined = undefined>({
  icon,
  title,
  description,
  error = false,
  onClick,
  submenus,
  loading = false,
  blockVisualization = true,
  role = undefined
}: MenuBlockDashProps<ROLE>) => {
  const { hasRole } = useAuth<ROLE>();

  const currentSubmenus = submenus?.filter(x => !!x);

  const submenusWithPermission = currentSubmenus?.filter(
    submenu => !submenu.role || hasRole(submenu.role)
  );

  const withoutPermissions = useMemo(() => {
    const roles = role ? (typeof role === 'string' ? [role] : role) : undefined;
    if (roles && roles.every(r => !hasRole(r))) {
      return true;
    }

    return !!currentSubmenus?.length && !submenusWithPermission?.length;
  }, [hasRole, submenus, role, role?.length]);

  return (
    <Only when={blockVisualization}>
      <BlockDash
        key={title}
        sm={3}
        md={3}
        loading={loading}
        icon={icon}
        title={title}
        description={
          withoutPermissions ? (
            <>
              <Icon icon="lock" /> Acesso restrito
            </>
          ) : (
            description
          )
        }
        alignItem="left"
        error={error && !withoutPermissions}
        className={`mb-xs visible=false${
          withoutPermissions ? ' disabled-block-dash' : ''
        }`}
        onClick={withoutPermissions ? undefined : onClick}
      >
        {!withoutPermissions && !!submenusWithPermission?.length && (
          <ul>
            {submenusWithPermission?.map(item => (
              <li
                key={`${item.descricao}`}
                onClick={item.onClickItem}
                role="button"
              >
                {item.descricao}
              </li>
            ))}
          </ul>
        )}
      </BlockDash>
    </Only>
  );
};

export { MenuBlockDash };
